import axios from 'axios'

class FeaturesService {
  constructor() {
    this.baseUrl = '/api/v1/features'
  }

  getFeatures(data) {
    return axios.post(`${this.baseUrl}/get-features/`, data)
  }

  saveAction(data) {
    return axios.post(`${this.baseUrl}/get-features/`, data)
  }
}

export const featuresService = new FeaturesService()
